import React, { Component } from 'react';

import ArticleSummary from '../article-summary/article-summary';
import TagsFiltersBar from '../../common/tags-filters-bar/tags-filters-bar';
import LoadingIndication from '../../common/loading-indicator';
import ArticleTags from '../../../services/article-tags/article-tags';
import AnimatedWrapper from '../../core/animated-wrapper';
import shareService from '../../../services/share';
import articlesService from '../../../services/articles';
import SmartAd from '../../ads/smart-ad';
import AdUIService from '../../../services/ads/ui';

import './articles.css';

// import articlesSummary from '../../../services/articles-data/articles-data';

class Articles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false,
      tags: ArticleTags.getMyArticleTags(),
      articles: [],
      shownArticles: []
    };

    shareService.setupPage({
      title: 'My Articles'
    });       
  }

  componentDidMount() {
    articlesService.getArticlesSummaries()
      .then((articles) => {
        this.setState({
          isLoading: false,
          articles: [...articles].reverse(),
          shownArticles: [...articles].reverse()
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          isError: true
        });
      });
  }

  onFilterClick = (filter) => {
    this.setState((prevState) => {
      return {
        shownArticles: prevState.articles.filter((article) => {
          return article.tags.indexOf(filter.id) !== -1;
        })
      }
    });
  }

  onClearAllClick = () => {
    this.setState((prevState) => {
      return {
        shownArticles: [...prevState.articles]
      }
    });    
  }
  
  getArticlesPartJSX() {
    if (this.state.articles.length === 0) {
      return (
        <p>There is no articles</p>
      );
    }

    const articles = this.state.shownArticles.map((article) => 
      <ArticleSummary {...article} key={article._id} />
    );
    
    return AdUIService.putEvery(articles, SmartAd, 1, 8, { forceShowAd: true });
  }

  render() {
    let extraJSX;
    
    if (this.state.isLoading) {
      extraJSX = (
        <LoadingIndication />
      );
    }
    else {
      extraJSX = (
        <div>
          <p className='shown-articles-count'>
            Show {this.state.shownArticles.length} out of {this.state.articles.length} articles
          </p>

          <div className='articles'>
            {this.getArticlesPartJSX()}
          </div>
        </div>
      );
    }

    return (
      <section className='regular-page articles-container'>
        <h3 className='page-title'>MY ARTICLES</h3>
        <hr className='title-separator' />

        <TagsFiltersBar 
          tags={this.state.tags}
          onFilterClick={this.onFilterClick}
          onClearAllClick={this.onClearAllClick} />

        {extraJSX}
      </section>
    );
  }
}


const AnimatedArticles = AnimatedWrapper(Articles);
export default AnimatedArticles;